import React, { useContext } from 'react';
import * as Styles from './FastCheckoutHeader.styles';
import { Button } from 'gatorcomponents';
import HgLogo from '../../media/logo_hg.svg';
import { ThemeContext } from 'styled-components';
import { IconArrowLeft } from '@/icons';

const FastCheckoutHeader = ({ handleBackNavigation, isMobile, locale }) => {
  const theme = useContext(ThemeContext);

  return (
    <Styles.Header>
      <Styles.BackButtonWrapper>
        <Button
          onClick={handleBackNavigation}
          variant="text"
          label={!isMobile && locale.backButton}
          size="large"
          iconLeft={(
            <IconArrowLeft
              size="14"
              color={theme.v2.colors.neutral.lowMedium}
            />
        )}
        />
      </Styles.BackButtonWrapper>
      <Styles.HgLogo alt="HostGator" src={HgLogo} />
    </Styles.Header>
  );
};

export default FastCheckoutHeader;
